<template>
  <button
    :class="[
      $style.base,
      {
        [$style.hasArrow]: showArrow,
        [$style.isSmall]: isSmall,
        [$style.fullWidth]: fullWidth,
        [$style.isLoading]: isLoading,
        [$style.isTouch]: device.touch,
        [$style.hasBorder]: inverted
      }
    ]"
    :style="{ borderColor: borderColor } as StyleValue"
  >
    <div
      :class="$style.inner"
      :style="{ backgroundColor: backgroundColor }"
      v-test="'base-button-inner'"
    >
      <IconSpinner v-if="isLoading" :isLight="true" />
      <div :class="$style.text" :style="{ color: borderColor } as StyleValue">
        <slot></slot>
      </div>
      <div :class="$style.arrow" v-if="showArrow">
        <IconArrow direction="right" white />
      </div>
    </div>
    <div :class="$style.bg" v-if="!device.touch"></div>
  </button>
</template>

<script lang="ts">
import IconArrow from '@/components/IconArrow.vue';
import IconSpinner from '@/components/IconSpinner.vue';
import { device } from '@/user-context';
import widgetSettings from '@/widget-settings';
import { StyleValue } from 'vue';

export default {
  components: {
    IconArrow,
    IconSpinner
  },
  props: {
    showArrow: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isSmall: {
      type: Boolean,
      default: false
    },
    buttonColor: {
      type: String,
      required: false
    },
    inverted: {
      type: Boolean,
      required: false
    },
    fullWidth: {
      type: Boolean,
      required: false
    }
  },
  setup() {
    return {
      device
    };
  },
  computed: {
    backgroundColor() {
      if (this.inverted) {
        return '#fff';
      }
      return this.buttonColor ? this.buttonColor : widgetSettings.color;
    },
    borderColor() {
      if (!this.inverted) {
        return null;
      }
      return this.buttonColor ? this.buttonColor : widgetSettings.color;
    }
  }
};
</script>

<style lang="scss" module>
$arrowWidth: 16px;
.base {
  position: relative;
  border-radius: 6px;
  cursor: pointer;

  &.isLoading {
    pointer-events: none;
  }

  &:not(.isTouch):hover {
    .inner {
      opacity: 0.85;
    }
  }

  &.fullWidth {
    display: block;
    width: 100%;
  }
}

.hasBorder {
  border: 1px solid;
}

.inner,
.bg {
  border-radius: inherit;
}

.inner {
  position: relative;
  z-index: 1;
  transition: opacity 0.15s;
}

.bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: white;
}

.text {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: $spacing $spacing $spacing + 4px $spacing;
  height: 50px;
  color: $color-font-light;
  font-size: 16px;
  font-weight: bold;
  .base.hasArrow & {
    padding-right: $spacing * 2 + $arrowWidth;
  }
  .base.isLoading & {
    opacity: 0;
    visibility: hidden;
  }
  .base.isSmall & {
    height: 20px;
    font-size: 12px;
    font-weight: normal;
  }
}

.arrow {
  display: flex;
  align-items: center;
  position: absolute;
  right: $spacing;
  top: 0;
  width: $arrowWidth;
  height: 100%;
}
</style>
